import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import Glyphicon from "../Glyphicon";
import { extractAirportName } from "../../utils/functions";

class Lotnisko extends PureComponent<any> {
  static contextType = AppContext;

  handleClick = () => {
    const { id } = this.props;
    const { showInfoWindow } = this.context;
    showInfoWindow("airport", id);
  };

  render() {
    const { id } = this.props;
    const { airports } = this.context;
    const airport = airports.filter((airport: any) => airport.id === id)[0];
    const name = extractAirportName(airports, id);
    return (
      <span>
        <button
          className="Lotnisko_button"
          title={"Zobacz kartę lotniska " + name}
          onClick={this.handleClick}
        >
          {name}
        </button>
        {airport.guides &&
          airport.guides.map((guide: any) => (
            <a
              key={guide.link}
              className="Lotnisko_button"
              title="Zobacz przewodnik"
              href={guide.link}
            >
              <Glyphicon className="Lotnisko_icon" icon="explore" />
            </a>
          ))}
        {airport.sleepingGuide && (
          <a
            className="Lotnisko_button"
            title="Zobacz poradnik"
            href={
              "http://tambylstwo.blogspot.com/2010/06/sztuka-taniego-latania-spanie-na.html#" +
              id
            }
          >
            <Glyphicon className="Lotnisko_icon" icon="airline_seat_flat" />
          </a>
        )}
      </span>
    );
  }
}

export default Lotnisko;
